module.exports = __webpack_public_path__ + "static/media/leave.751bda56.svg";